import { UserDto } from "../../../types/dto";
import { getBlast, isMockMode, simulateDelay } from "../../api";

// `search` drives the server-side FilterCriteria.Base user search (name/email),
// so large orgs (>500 users) never ship the whole list. Omit it to load the
// first `take` users (name-sorted). Results are name-sorted server-side.
export const getUsersForOrg = ({
	orgId,
	search,
	take,
}: {
	orgId: string;
	search?: string;
	take?: number;
}) => {
	if (isMockMode()) {
		const testData = {
			results: [
				{
					id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
					email: "test.mctestie@mgaol.abc",
					firstName: "Test",
					lastName: "McTestie",
				},
			],
		};

		return simulateDelay(50, () => testData) as Promise<{
			results: Array<UserDto>;
		}>;
	}

	const params = new URLSearchParams({ orgId });
	if (search) {
		params.set("FilterCriteria.Base", search);
	}
	if (take != null) {
		params.set("take", String(take));
	}

	return getBlast(`orgusers/getusersfororg?${params.toString()}`) as Promise<{
		results: Array<UserDto>;
	}>;
};
